import { startFallingLayer } from './falling_layer';

var CONFETTI_COLORS = ['#E9B949', '#C8901C', '#F7DC9A', '#A6388C', '#E07BC6', '#724A88', '#C9CED8'];
var FIREWORKS_ON_LIGHT = [
  ['#E9B949', '#F7DC9A', '#C8901C'],   // dourado
  ['#A6388C', '#E07BC6', '#C04AA2'],   // marca
  ['#724A88', '#A6388C', '#E9B949']    // roxo com dourado
];
var FIREWORKS_ON_DARK = [
  ['#F7DC9A', '#E9B949', '#FFFFFF'],   // champanhe e dourado
  ['#F4A9DD', '#E07BC6', '#FFF3D6'],   // rosa claro
  ['#FFFFFF', '#F7DC9A', '#E07BC6']    // branco com dourado e rosa
];

var stops = [];

function stopAll() {
  stops.forEach(function(stop) { stop(); });
  stops = [];
}

//
// Confete
//
function makeConfetti(width, height) {
  var round = Math.random() < 0.2; // algumas lantejoulas redondas no meio dos papeizinhos
  return {
    x: Math.random() * width,
    y: Math.random() * height,
    w: round ? 5 : 4 + Math.random() * 3,
    h: round ? 5 : 7 + Math.random() * 5,
    round: round,
    color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
    speed: 34 + Math.random() * 34,
    sway: 12 + Math.random() * 26,
    phase: Math.random() * Math.PI * 2,
    angle: Math.random() * Math.PI * 2,
    spin: (Math.random() - 0.5) * 3,
    flip: Math.random() * Math.PI * 2,
    flipSpeed: 3 + Math.random() * 4
  };
}

function drawConfetti(ctx, c, x, dt) {
  c.angle += c.spin * dt;
  c.flip += c.flipSpeed * dt;
  ctx.save();
  ctx.translate(x, c.y);
  ctx.rotate(c.angle);
  ctx.scale(1, Math.cos(c.flip)); // o papel "vira": achata e abre
  ctx.globalAlpha = 0.88;
  ctx.fillStyle = c.color;
  if (c.round) {
    ctx.beginPath();
    ctx.arc(0, 0, c.w / 2, 0, Math.PI * 2);
    ctx.fill();
  } else {
    ctx.fillRect(-c.w / 2, -c.h / 2, c.w, c.h);
  }
  ctx.restore();
}

//
// Fogos de artifício
//
function startFireworks(section, palettes) {
  var canvas = document.createElement('canvas');
  canvas.className = 'cda-fireworks';
  canvas.setAttribute('aria-hidden', 'true');
  section.insertBefore(canvas, section.firstChild);

  var ctx = canvas.getContext('2d');
  var sparks = [];
  var width = 0;
  var height = 0;
  var frame = null;
  var last = 0;
  var nextBurst = 0.4;
  var visible = true;

  function resize() {
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    width = section.clientWidth;
    height = section.clientHeight;
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function burst() {
    var palette = palettes[Math.floor(Math.random() * palettes.length)];
    var cx = width * (0.08 + Math.random() * 0.84);
    var cy = height * (0.1 + Math.random() * 0.4);
    var count = width < 600 ? 30 : 48;
    var power = width < 600 ? 0.75 : 1;
    for (var i = 0; i < count; i++) {
      var angle = (i / count) * Math.PI * 2 + Math.random() * 0.2;
      var speed = (90 + Math.random() * 110) * power;
      sparks.push({
        x: cx, y: cy, px: cx, py: cy,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        age: 0,
        life: 1.3 + Math.random() * 0.7,
        color: palette[i % palette.length]
      });
    }
  }

  function draw(dt) {
    ctx.clearRect(0, 0, width, height);
    nextBurst -= dt;
    if (nextBurst <= 0) {
      burst();
      nextBurst = 1.5 + Math.random() * 1.5;
    }
    ctx.lineCap = 'round';
    for (var i = sparks.length - 1; i >= 0; i--) {
      var s = sparks[i];
      s.age += dt;
      if (s.age >= s.life) { sparks.splice(i, 1); continue; }
      var drag = Math.pow(0.2, dt); // freia rápido, como a explosão perdendo força
      s.vx *= drag;
      s.vy = s.vy * drag + 70 * dt; // gravidade
      s.px = s.x; s.py = s.y;
      s.x += s.vx * dt;
      s.y += s.vy * dt;
      var fade = Math.pow(1 - s.age / s.life, 1.4);
      ctx.globalAlpha = 0.85 * fade;
      ctx.strokeStyle = s.color;
      ctx.lineWidth = 2.4;
      ctx.beginPath();
      // rastro curto do brilho
      ctx.moveTo(s.x - s.vx * 0.08, s.y - s.vy * 0.08);
      ctx.lineTo(s.x, s.y);
      ctx.stroke();
    }
    ctx.globalAlpha = 1;
  }

  function tick(now) {
    var dt = last ? Math.min((now - last) / 1000, 0.05) : 0;
    last = now;
    draw(dt);
    frame = requestAnimationFrame(tick);
  }

  function play() {
    if (frame || !visible || document.hidden) return;
    last = 0;
    frame = requestAnimationFrame(tick);
  }

  function pause() {
    if (frame) cancelAnimationFrame(frame);
    frame = null;
  }

  var observer = new IntersectionObserver(function(entries) {
    visible = entries[0].isIntersecting;
    if (!visible) return pause();
    // mede de novo ao entrar na tela: seções fora da tela (content-visibility) ainda não têm a
    // altura real, e o canvas sairia esticado
    resize();
    play();
  });
  observer.observe(section);

  function onVisibility() { document.hidden ? pause() : play(); }
  document.addEventListener('visibilitychange', onVisibility);

  var resizeTimer = null;
  function onResize() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resize, 150);
  }
  window.addEventListener('resize', onResize);

  resize();
  play();

  return function stop() {
    pause();
    observer.disconnect();
    document.removeEventListener('visibilitychange', onVisibility);
    window.removeEventListener('resize', onResize);
    clearTimeout(resizeTimer);
    canvas.remove();
  };
}

document.addEventListener('turbolinks:load', function() {
  stopAll();
  if (!document.body.classList.contains('cda-season--new-year')) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // menos confete que flocos de neve: os papeizinhos são coloridos e chamam mais atenção
  stops.push(startFallingLayer({ density: 26000, max: 45, make: makeConfetti, draw: drawConfetti }));

  var hero = document.querySelector('.cda-how');
  if (hero) stops.push(startFireworks(hero, FIREWORKS_ON_LIGHT));
  var footerCta = document.querySelector('.cda-footer-cta');
  if (footerCta) stops.push(startFireworks(footerCta, FIREWORKS_ON_DARK));
});

// tira tudo antes de o Turbolinks guardar a página em cache (a volta cria de novo)
document.addEventListener('turbolinks:before-cache', stopAll);
